import { types } from "../types/types";
import { startSpinner, finishSpinner } from "./ui/spinner";
import TipoYSubtipoEfectoresService from '../services/TipoYSubtipoEfectoresService'
import { startAlerta } from "./ui/alertas";

export const fetchTipoEfectores = () => async (dispatch) => {
  dispatch(startSpinner())
  dispatch({ type: types.tipoEfectoresTraerStart })
  try {
      const result = await TipoYSubtipoEfectoresService.getTiposEfectores()
      const body = await result.json()
      if (result.ok) {
          dispatch({
              type: types.tipoEfectoresTraerSuccess,
              payload: body
          })
          dispatch(finishSpinner())
      } else {
          throw body
      }

  } catch (error) {
      dispatch({ type: types.tipoEfectoresTraerError })
      dispatch(finishSpinner())
      if (error.errores && error.errores.mensaje) {
          dispatch(startAlerta(error.errores.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
}

export const fetchSubTipoEfectores = (idTipoEfector=null) => async (dispatch) => {
    dispatch(startSpinner())
    dispatch({ type: types.subtipoEfectoresTraerStart })
    try {
        let result = null
        if(idTipoEfector){
            result= await TipoYSubtipoEfectoresService.getSubtiposXTipoEfectores(idTipoEfector)
        }else{
            result= await TipoYSubtipoEfectoresService.getSubTiposEfectores()
        }        
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.subtipoEfectoresTraerSuccess,
                payload: body
            })
            dispatch(finishSpinner())
        } else {
            throw body
        }
  
    } catch (error) {
        dispatch({ type: types.subtipoEfectoresTraerError })
        dispatch(finishSpinner())
        if (error.errores && error.errores.mensaje) {
            dispatch(startAlerta(error.errores.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
  }
